import MicroModal from 'micromodal';
import { createFormAnalytics } from '../helpers/form-analytics';

const contestSubmissionFormSelector = '.js-contest-submission-form',
  submissionProcessingModalID = '#contest-submission-processing-modal',
  submissionSuccessModalID = '#contest-submission-success-modal',
  urlParams = new URLSearchParams(window.location.search),
  openSuccessModal = urlParams.get('contestSubmissionSuccess') === '1',
  openFailureModal = urlParams.get('contestSubmissionSuccess') === '0';

const contestSubmissionModals = async () => {
  const contestSubmissionForm = document.querySelector(
    contestSubmissionFormSelector
  );
  reportSubmissionAnalytics(contestSubmissionForm);
  if (contestSubmissionForm) {
    contestSubmissionForm.addEventListener('submit', logSubmissionPayload);
    contestSubmissionForm.addEventListener('submit', showProcessingModal);
    gateSubmitOnTermsAcceptance(contestSubmissionForm);
  }

  if (openSuccessModal)
    setTimeout(() => {
      MicroModal.show(submissionSuccessModalID);
    }, 500);

  // currently not implemented
  if (openFailureModal && false)
    setTimeout(() => {
      MicroModal.show(submissionFailureModalID);
    }, 500);
};

// The entry posts to Rails and comes back with contestSubmissionSuccess, so
// the returning page reports the outcome rather than the view.
const reportSubmissionAnalytics = form => {
  const formAnalytics = createFormAnalytics(
    'Contest|Contest Entry',
    () => form
  );

  if (openSuccessModal) formAnalytics.submit();
  else if (openFailureModal) formAnalytics.error();
  else if (form) formAnalytics.view();

  // A reload of the returning page would report the outcome a second time.
  if (urlParams.has('contestSubmissionSuccess')) {
    urlParams.delete('contestSubmissionSuccess');
    const query = urlParams.toString();
    history.replaceState(
      null,
      '',
      `${window.location.pathname}${query ? `?${query}` : ''}${
        window.location.hash
      }`
    );
  }

  if (!form) return;
  form.addEventListener('input', () => formAnalytics.start());
  form.addEventListener('change', () => formAnalytics.start());

  // invalid fires once per field and doesn't bubble; one error per attempt.
  let reportedInvalid = false;
  form.addEventListener(
    'invalid',
    () => {
      if (reportedInvalid) return;
      reportedInvalid = true;
      formAnalytics.error();
      setTimeout(() => (reportedInvalid = false));
    },
    true
  );
};

const showProcessingModal = _event => {
  MicroModal.show(submissionProcessingModalID);
};

// Retained for ongoing debugging of the category -> Photoshelter
// (libris_collection) routing. Enable "Preserve log" in the browser console
// to read the output after the post-submit redirect.
const logSubmissionPayload = event => {
  const payload = new FormData(event.currentTarget);
  console.log(
    '[contest-submission] contest_category_assignment_id:',
    payload.get('contest_submission[contest_category_assignment_id]')
  );
};

const gateSubmitOnTermsAcceptance = form => {
  const termsCheckbox = form.querySelector(
    '#contest_submission_terms_and_conditions_accepted'
  );
  const submitButton = form.querySelector('#contest_submission_commit');
  if (!termsCheckbox || !submitButton) return;

  const syncSubmitState = () => {
    const isDisabled = !termsCheckbox.checked;
    submitButton.disabled = isDisabled;
    submitButton.classList.toggle('cta-button--disabled', isDisabled);
  };

  syncSubmitState();
  termsCheckbox.addEventListener('change', syncSubmitState);
};

export default {
  init: contestSubmissionModals,
};
